import { render, staticRenderFns } from "./mp.vue?vue&type=template&id=f938811c&scoped=true&"
import script from "./mp.vue?vue&type=script&lang=js&"
export * from "./mp.vue?vue&type=script&lang=js&"
import style0 from "./mp.vue?vue&type=style&index=0&id=f938811c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f938811c",
  null
  
)

export default component.exports